import { MAILTO } from "@/lib/site";

const CARDS = [
  {
    tag: "Fatty Acid + Phytochemical Profile",
    title: "Botanical Potency Profile",
    stats: [
      { num: "35%", mark: "*", label: "Omega-7 concentration", sub: "High-value fruit oil marker" },
      { num: "15x", mark: "†", label: "Vitamin C vs. oranges", sub: "Functional pulp story" },
      { num: "190+", mark: "‡", label: "bioactive compounds", sub: "Omegas, carotenoids, flavonoids" },
    ],
    citation: (
      <>
        <span>* </span>Source: Zielińska, A. &amp; Nowak, I. (2017). <em>Abundance of active ingredients in
        sea-buckthorn oil.</em> Lipids in Health and Disease, 16, 95.
        <br />†‡ Based on standard phytochemical and fatty acid composition analysis of premium sea buckthorn fruit oil.
      </>
    ),
  },
  {
    tag: "Clinical Study",
    title: "Oral Beauty Outcomes",
    stats: [
      { num: "49%", mark: "*", label: "skin hydration improvement", sub: "Hydration support" },
      { num: "26%", mark: "*", label: "skin elasticity increase", sub: "Firmer skin positioning" },
      { num: "11%", mark: "*", label: "wrinkle depth reduction", sub: "Visible aging story" },
    ],
    citation: (
      <>
        <span>* </span>Sung, H.K. et al. (2024). <em>Anti-wrinkle and skin moisture efficacy of 7-MEGA™: A randomized,
        double-blind, placebo comparative clinical trial.</em>
      </>
    ),
  },
  {
    tag: "Preclinical Skin Research",
    title: "Skin Barrier Research Signals",
    stats: [
      { num: "40%", mark: "*", label: "IL-1β reduction", sub: "Inflammation marker" },
      { num: "33%", mark: "*", label: "IL-6 reduction", sub: "Immune-response marker" },
      { num: "15 Days", mark: "*", label: "measurable symptom signal", sub: "Barrier-response timeline" },
    ],
    citation: (
      <>
        <span>* </span>Based on a 2020 controlled clinical study published in BMC Complementary Medicine and
        Therapies evaluating the ameliorative effects of Sea Buckthorn Oil on atopic dermatitis and systemic
        Th1/Th2 balance.
      </>
    ),
  },
];

const REFS = [
  { author: "Zielińska & Nowak, 2017", title: "Abundance of active ingredients in sea-buckthorn oil" },
  { author: "Sung et al., 2024", title: "Anti-wrinkle and skin moisture efficacy of 7-MEGA™" },
  { author: "BMC Complementary Medicine and Therapies, 2020", title: "Sea buckthorn oil and atopic-dermatitis model research" },
  { author: "Yang et al., 2011", title: "Chronic administration of palmitoleic acid and metabolic-health markers" },
];

export default function AboutBerry() {
  return (
    <section id="berry" className="section berry-evidence buyers-bg" data-testid="berry-section">
      <div className="buyers-photo-layer" style={{ backgroundImage: "url(/images/why-buyers.jpg)" }} aria-hidden="true" />
      <div className="buyers-overlay" aria-hidden="true" />
      <div className="wrap" style={{ position: "relative", zIndex: 1 }}>
        <div className="berry-top">
          <div className="berry-top-left">
            <div className="eyebrow">About Sea Buckthorn</div>
            <h2>Why consumers choose sea buckthorn.</h2>
          </div>
          <div className="berry-top-right">
            <div className="berry-intro-box">
              <p>
                Sea buckthorn is a bright orange Himalayan berry found in cold, high-altitude regions including
                Ladakh and the wider Himalayan belt. For product teams, its value is not only its origin story — it
                is the way one berry can support multiple consumer-facing product stories across beauty, wellness,
                nutrition and personal care.
              </p>
            </div>
          </div>
        </div>

        <div className="evidence-shell" data-testid="evidence-shell">
          <div className="evidence-board">
            <div className="evidence-board-head">
              <h3 className="evidence-board-title">Evidence buyers can build around.</h3>
              <span className="pill-dark">Research-backed ingredient evidence</span>
            </div>

            <div className="evidence-grid">
              {CARDS.map((c, i) => (
                <article className="evidence-card" key={i} data-testid={`evidence-card-${i}`}>
                  <span className="pill-tag">{c.tag}</span>
                  <h4 className="evidence-card-title">{c.title}</h4>
                  <div className="stat-stack">
                    {c.stats.map((s, j) => (
                      <div className="stat-block" key={j}>
                        <div className="stat-block-num">
                          {s.num}
                          <sup>{s.mark}</sup>
                        </div>
                        <div className="stat-block-label">{s.label}</div>
                        <div className="stat-block-sub">{s.sub}</div>
                      </div>
                    ))}
                  </div>
                  <div className="evidence-citation">{c.citation}</div>
                </article>
              ))}
            </div>
          </div>

          <div className="research-pack" data-testid="research-pack">
            <div className="research-pack-head">
              <h3 className="research-pack-title">Available in the Buyer Research Pack</h3>
              <a className="pill-cta" href={MAILTO} data-testid="research-pack-request">
                Request on enquiry
              </a>
            </div>
            <p className="research-pack-copy">
              For qualified buyers, we can share supporting references and technical notes covering omega-7
              composition, skin hydration and elasticity research, sea buckthorn oil in dermatology applications,
              atopic-dermatitis model research, palmitoleic-acid metabolic research and product-format-specific
              documentation.
            </p>
            <div className="ref-grid">
              {REFS.map((r, i) => (
                <div className="ref-tile" key={i} data-testid={`ref-tile-${i}`}>
                  <div className="ref-author">{r.author}</div>
                  <div className="ref-title">{r.title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
